module.exports = __webpack_public_path__ + "img/rectangle-wide.b3ad952f.svg";